/*
 *
 * ChannelsPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Outlet } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { selectAllChannels } from './selectors';
import { Wrapper } from './styledComponents';

class ChannelsPage extends React.PureComponent {
  render() {
    return (
      <Wrapper>
        <HelmetProvider>
          <Helmet title='Movebooth | Channels' />
        </HelmetProvider>
        <div className='channels-page__content'>
          <Outlet />
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  channels: selectAllChannels()
});

export default connect(mapStateToProps)(ChannelsPage);
